module.exports = __webpack_public_path__ + "static/media/8200.4d4e1558.jpg";